import { createSlice } from '@reduxjs/toolkit';

interface BlockMovementState {
	byId: { bloqueKey: string; isMovementDisabled: boolean; isSaved?: boolean }[];
	allIds: string[];
	allowMovement: boolean;
}

const initialState: BlockMovementState = {
	byId: [],
	allIds: [],
	allowMovement: true
};

const blockMovementSlice = createSlice({
	name: 'blockMovement',
	initialState,
	reducers: {
		setBlockMovementState: (state, action) => {
			const { bloqueKey, movementState } = action.payload;

			if (state.allIds.includes(bloqueKey)) {
				return {
					...state,
					byId: state.byId.map((b) =>
						b.bloqueKey === bloqueKey ? { ...b, isMovementDisabled: movementState } : b
					)
				};
			}
			return state;
		},
		resetBlockMovementState: () => initialState,
		toggleBlockMovementState: (state, action) => {
			const { bloqueKey } = action.payload;

			if (state.allIds.includes(bloqueKey)) {
				return {
					...state,
					byId: state.byId.map((b) =>
						b.bloqueKey === bloqueKey ? { ...b, isMovementDisabled: !b.isMovementDisabled } : b
					)
				};
			}
			return {
				byId: [...state.byId, { bloqueKey, isMovementDisabled: true }],
				allIds: [...state.allIds, bloqueKey],
				allowMovement: true
			};
		},
		setBlockSaved: (state, action) => {
			const { bloqueKey } = action.payload;
			return {
				...state,
				byId: state.byId.map((b) =>
					b.bloqueKey === bloqueKey ? { ...b, isMovementDisabled: false, isSaved: true } : b
				)
			};
		},
		resetBlockSaved: (state, action) => {
			const { bloqueKey } = action.payload;
			return {
				...state,
				byId: state.byId.map((b) => (b.bloqueKey === bloqueKey ? { ...b, isSaved: false } : b))
			};
		},
		removeBlockState: (state, action) => {
			const { bloqueKey } = action.payload;
			return {
				...state,
				byId: state.byId.filter((b) => b.bloqueKey !== bloqueKey),
				allIds: state.allIds.filter((id) => id !== bloqueKey)
			};
		},
		setAllowDragMovement: (state, action) => {
			const { allowMovement } = action.payload;
			return {
				...state,
				allowMovement
			};
		}
	}
});

export const {
	setBlockMovementState,
	resetBlockMovementState,
	toggleBlockMovementState,
	setBlockSaved,
	resetBlockSaved,
	removeBlockState,
	setAllowDragMovement
} = blockMovementSlice.actions;
export default blockMovementSlice.reducer;
